// Move the live results into the browser's modal top layer; never reload or clone them.
let activeReport = null;

function closeReport({ restoreFocus = true } = {}) {
  if (!activeReport) return;
  const state = activeReport;
  activeReport = null;
  state.placeholder.replaceWith(state.panel);
  state.dialog.close();
  state.dialog.remove();
  document.documentElement.classList.remove("report-fullscreen-open");
  document.body.classList.remove("report-fullscreen-open");
  state.scrollAreas.forEach(({ element, left, top, tabindex }) => {
    element.scrollLeft = left;
    element.scrollTop = top;
    if (tabindex === null) element.removeAttribute("tabindex");
    else element.setAttribute("tabindex", tabindex);
  });
  state.trigger.setAttribute("aria-expanded", "false");
  if (restoreFocus && state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
  window.scrollTo({ left: state.left, top: state.top, behavior: "instant" });
}

function openReport(trigger) {
  const panel = trigger.closest("[data-report-fullscreen-panel]");
  if (!panel || activeReport || typeof HTMLDialogElement === "undefined") return;

  const dialog = document.createElement("dialog");
  dialog.className = "report-fullscreen-dialog";
  dialog.setAttribute("aria-label", panel.dataset.reportFullscreenPanel || "Report results");
  const controls = document.createElement("div");
  controls.className = "report-fullscreen-controls";
  const title = document.createElement("h2");
  title.className = "report-fullscreen-title";
  title.textContent = panel.dataset.reportFullscreenPanel || "Report results";
  const zoomControls = document.createElement("div");
  zoomControls.className = "report-fullscreen-zoom";
  zoomControls.setAttribute("role", "group");
  zoomControls.setAttribute("aria-label", "Report zoom");
  const zoomButton = (label, text) => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "btn report-fullscreen-zoom-button";
    button.setAttribute("aria-label", label);
    button.title = label;
    button.textContent = text;
    return button;
  };
  const zoomOut = zoomButton("Zoom out", "−");
  const zoomReset = zoomButton("Reset report zoom to 100%", "100%");
  const zoomIn = zoomButton("Zoom in", "+");
  zoomReset.classList.add("report-fullscreen-zoom-reset");
  zoomReset.setAttribute("aria-live", "polite");
  let zoom = 100;
  const setZoom = (value) => {
    const previousZoom = zoom;
    zoom = Math.min(200, Math.max(50, value));
    const positions = scrollAreas.map(({ element }) => ({ element, left: element.scrollLeft, top: element.scrollTop }));
    dialog.style.setProperty("--report-results-zoom", String(zoom / 100));
    zoomReset.textContent = `${zoom}%`;
    zoomOut.disabled = zoom === 50;
    zoomIn.disabled = zoom === 200;
    positions.forEach(({ element, left, top }) => {
      element.scrollLeft = left * zoom / previousZoom;
      element.scrollTop = top * zoom / previousZoom;
    });
  };
  zoomOut.addEventListener("click", () => setZoom(zoom - 10));
  zoomIn.addEventListener("click", () => setZoom(zoom + 10));
  zoomReset.addEventListener("click", () => setZoom(100));
  zoomControls.append(zoomOut, zoomReset, zoomIn);
  const closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "btn report-fullscreen-close";
  closeButton.setAttribute("aria-label", "Close full screen");
  closeButton.innerHTML = '<i class="fa-solid fa-xmark" aria-hidden="true"></i>';
  controls.append(title, zoomControls, closeButton);
  dialog.append(controls);

  const placeholder = document.createComment("report results position");
  const scrollAreas = Array.from(panel.querySelectorAll(".admin-server-table-wrap, [data-report-fullscreen-scroll], .booking-grid, .admin-table-wrapper")).map((element) => ({
    element, left: element.scrollLeft, top: element.scrollTop, tabindex: element.getAttribute("tabindex"),
  }));
  activeReport = { panel, dialog, placeholder, trigger, scrollAreas, left: window.scrollX, top: window.scrollY };

  // Keep the dialog beneath the original styling ancestors, including .admin-shell.
  panel.before(placeholder, dialog);
  dialog.append(panel);
  document.documentElement.classList.add("report-fullscreen-open");
  document.body.classList.add("report-fullscreen-open");
  scrollAreas.forEach(({ element }) => element.setAttribute("tabindex", "0"));
  trigger.setAttribute("aria-expanded", "true");
  closeButton.addEventListener("click", () => closeReport());
  dialog.addEventListener("cancel", (event) => {
    event.preventDefault();
    closeReport();
  });
  dialog.addEventListener("close", () => {
    if (activeReport?.dialog === dialog) closeReport();
  });
  dialog.showModal();
  closeButton.focus({ preventScroll: true });
  scrollAreas.forEach(({ element, left, top }) => {
    element.scrollLeft = left;
    element.scrollTop = top;
  });
}

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-report-fullscreen-open]");
  if (!trigger) return;
  event.preventDefault();
  openReport(trigger);
});

for (const event of ["turbo:before-visit", "turbo:before-cache", "turbo:before-render"]) {
  document.addEventListener(event, () => closeReport({ restoreFocus: false }));
}
window.addEventListener("pagehide", () => closeReport({ restoreFocus: false }));
